import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';
import {
  getTestimonials,
  getTestimonialsFetching,
} from '../../store/testimonials/selectors';
import { loadTestimonials } from '../../store/testimonials/actions';
import TestimonialsPropType from '../../proptypes/testimonials';
import Testimonial from '../../components/Testimonial';
import Preloader from '../../../../../../components/Preloader';
import TestimonialMobile from '../../components/Testimonial/TestimonialMobile';
import withMobile from '../../hocs/withMobile';

const baseCls = 'checkout-testimonials';

const Testimonials = ({ items, load, isFetching, isMobile }) => {
  const { t } = useTranslation();
  const TestimonialComp = isMobile ? TestimonialMobile : Testimonial;
  const LoadButton = (
    <Button
      size="flex"
      functional={!isMobile}
      type="button"
      onClick={load}
      disabled={isFetching}
      className={cn(`${baseCls}__cn-button`, {
        'functional-button': !isMobile,
        'lt-link': !isMobile,
      })}
    >
      {t('checkout.testimonial.show', {
        context: isMobile ? 'mobile' : 'desktop',
      })}
    </Button>
  );
  return (
    <div className={baseCls}>
      <div className={`${baseCls}__title`}>
        <h2 className="like-h2">{t('checkout.testimonial.title')}</h2>
        {!isMobile && LoadButton}
      </div>
      <div style={{ position: 'relative', opacity: isFetching ? 0.5 : 1 }}>
        {isFetching && <Preloader throbber />}
        {items &&
          items.map((item) => <TestimonialComp key={item.id} data={item} />)}
        {isMobile && LoadButton}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  items: getTestimonials(state),
  isFetching: getTestimonialsFetching(state),
});

const mapDispatchToProps = (dispatch) => ({
  load: () => dispatch(loadTestimonials()),
});

Testimonials.defaultProps = {
  items: null,
};

Testimonials.propTypes = {
  items: PropTypes.arrayOf(TestimonialsPropType),
  isFetching: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  load: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobile(Testimonials));
